// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1qZp9","content":"LoadingAlert_content__2RDqD"};